export function showURL(studentID) {
  // console.log("studentData !?", studentID);
  let yearId = studentID.slice(0, 2);
  let url = `https://datasoft.co.th/mvc_eye_depart/images/student/${yearId}/${studentID}.jpg`;
  // let url = `http://11.0.0.106/mvc_eye_depart/images/student/${yearId}/${studentID}.jpg`;

  return url;
}
